import Q15 from './Q15';

export default Q15;
